import type { IChannel } from "containers/Channels/types";

export const getSavedChannelSettings = (savedValue: boolean | string) => {
    try {
        if (savedValue === true || savedValue === false) {
            return [];
        }
        const parsed = savedValue ? JSON.parse(savedValue as string) : [];
        return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch {
        return [];
    }
};

export const getChannelIdsFromNames = (channels: { id: number; name: string }[], names: string[]) => {
    return channels.filter((channel) => names.includes(channel.name || "")).map((channel) => Number(channel.id));
};

export const getChannelSelectorOptions = (channelIds: number[] | string[], channels: IChannel[]) => {
    return channelIds
        .map((id) => {
            const channel = channels.find((ch) => String(ch.id) === String(id));
            return channel ? { id: Number(channel.id), name: channel.name || "", color: 0 } : null;
        })
        .filter((obj): obj is { id: number; name: string; color: number } => obj !== null);
};
